module.exports = __webpack_public_path__ + "static/img-f46ee790d9a5c5c073ee3eb4dadb076c.png";